// src/contexts/LicenseContext.js
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const LicenseContext = createContext();

export const LicenseProvider = ({ children }) => {
  const [license, setLicense] = useState([]);
  const [loadingLicense, setLoadingLicense] = useState(true);
  const [errorLicense, setErrorLicense] = useState(null);

  const PREISE_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Fuehrerscheine?fields=*.*';

  useEffect(() => {
    const ac = new AbortController();
    const fetchLicense = async () => {
      setLoadingLicense(true); setErrorLicense(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(PREISE_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        console.log(res);
        setLicense(res?.data?.data ?? []);
      } catch (e) {
        if(axios.isCancel(e)) {console.log(e); }
        if (!ac.signal.aborted) setErrorLicense('Fehler beim Laden der Fuehrerscheine');
      } finally {
        if (!ac.signal.aborted) setLoadingLicense(false);
      }
    };
    fetchLicense();
    /* return () => ac.abort(); */
  }, []);

  return (
    <LicenseContext.Provider value={{ license, loadingLicense, errorLicense }}>
      {children}
    </LicenseContext.Provider>
  );
};
